var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false && _vm.hover != false)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"size":"20","color":''},domProps:{"textContent":_vm._s('mdi-lock')}},on))]}}],null,false,2398238075)},[_vm._v(" "+_vm._s(_vm.$t('servicesystem.common_objects.fallbackterms.locked_field'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }